module.exports = __webpack_public_path__ + "components/MapControl/svg/Cerkiew.svg?15844493";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Cerkiew.svg
// module id = 1958
// module chunks = 0